import React from "react"
import Helmet from "react-helmet"
import { ThemeProvider } from "styled-components"

import { GlobalStyle } from "./globalStyle"
import { colors } from "./colors"

const baselineratio = 16 / 9
const basegrid = [28, 32, 36]

const theme = {
  colors: {
    ...colors,
    background: "#f7f7f7",
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.25rem",
    xl: "1.5rem",
    xxl: "2.25rem",
    xxxl: "3rem",
  },
  fontWeight: {
    thin: 300,
    normal: 400,
    semiBold: 500,
    bold: 600,
    bolder: 700,
  },
  breakpoints: [312, 624, 936, 1248],
  baseline: baselineratio * 1 + "rem",
  basefont: {
    mobile: basegrid[1] / baselineratio + "px",
    tablet: basegrid[0] / baselineratio + "px",
    laptop: basegrid[1] / baselineratio + "px",
    wide: basegrid[2] / baselineratio + "px",
  },
  space: [],
  typescale: [1.15, 1.25],
}

theme.breakpoints.mobile = `${theme.breakpoints[0]}px`
theme.breakpoints.tablet = `${theme.breakpoints[1]}px`
theme.breakpoints.laptop = `${theme.breakpoints[2]}px`
theme.breakpoints.wide = `${theme.breakpoints[3]}px`

for (let i = 0; i < 4.5; i += 0.25) {
  theme.space.push(`${i}rem`)
}

const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>
    <Helmet>
      <link
        rel="preload"
        href="https://fonts.googleapis.com/css?family=Dancing+Script|Roboto&display=swap"
        as="style"
      />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Dancing+Script|Roboto&display=swap"
        type="text/css"
      ></link>

      <link
        rel="preload"
        href="https://pro.fontawesome.com/releases/v5.2.0/css/all.css"
        as="style"
      ></link>
      <link
        rel="stylesheet"
        href="https://pro.fontawesome.com/releases/v5.2.0/css/all.css"
      ></link>
    </Helmet>
    <GlobalStyle />
    {children}
  </ThemeProvider>
)

export { theme }
export default Theme
